import React, { useEffect, useState } from "react";
import CreateStudents from "./CreateStudents";
import StudentsSearchSec from "./StudentsSearchSec";
import NoStudents from "./NoStudents";
import AllStudentsMain from "./AllStudentsMain";
import { manageStudents } from "../../../../api/org-admin";
import WebUtils from "../../../../utils/WebUtils";
import Utils from "../../../../utils/Utils";
import Loader from "../../../Loader";

function ManageStudentsMain() {
  const userDetail = Utils.getUserDetail();
  const [createbatchFlag, setCreateBatchFlag] = useState(false);
  const [studentsData, setStudentsData] = useState([]);
  const [loading, setLoading] = useState(null);

  const [searchText, setSearchText] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [sortBy, setSortBy] = useState("SORT_BY_CREATION_DATE_DESC");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(5);
  const [pageSize, setPageSize] = useState(5);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [refressTrigger, setRefressTrigger] = useState(0);

  const getStudentData = (currPage, pageSize, searchInput) => {
    const url = `${manageStudents}`;

    let reqBody = {
      organizationId: userDetail?.organizationId,
      sortBy: sortBy,
      searchValue: searchInput,
      pageNumber: currPage,
      pageSize: pageSize,
    };
    setLoading(true);

    WebUtils.httpOperations(url, reqBody, "POST")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setStudentsData(result?.data?.data?.students);
          setPageCount(result?.data?.data?.totalCount);
        } else {
          setStudentsData([]);
          setPageCount(0);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const onPageChange = (num, pageSize) => {
    setCurrentPage(num - 1);
    setPageSize(pageSize);
  };

  const refreshApis = () => {
    // getStudentData(0, 5, "");
    setPageSize(5);
    setCurrentPage(0);
    setSearchValue("");
    setSearchText("");
    setRefressTrigger((prev) => prev + 1);
  };

  const sortItems = [
    {
      key: "SORT_BY_CREATION_DATE_ASC",
      label: "Creation Date (Old-New)",
    },
    {
      key: "SORT_BY_CREATION_DATE_DESC",
      label: "Creation Date (New-Old)",
    },
    {
      key: "SORT_BY_CANDIDATE_NAME_ASC",
      label: "Candidate Name (A-Z)",
    },
    {
      key: "SORT_BY_CANDIDATE_NAME_DESC",
      label: "Candidate Name (Z-A)",
    },
  ];

  useEffect(() => {
    getStudentData(currentPage, pageSize, searchValue);
  }, [pageSize, currentPage, sortBy, searchValue,refressTrigger]);

  return (
    <>
      {loading && <Loader />}
      <div>
        {createbatchFlag ? (
          <CreateStudents setCreateBatchFlag={setCreateBatchFlag} />
        ) : studentsData?.length > 0 ? (
          <AllStudentsMain
            studentsData={studentsData}
            setCreateBatchFlag={setCreateBatchFlag}
            setSortBy={setSortBy}
            sortBy={sortBy}
            sortItems={sortItems}
            setPageSize={setPageSize}
            pageSize={pageSize}
            onPageChange={onPageChange}
            currentPage={currentPage}
            pageCount={pageCount}
            setSearchValue={setSearchValue}
            searchValue={searchValue}
            searchText={searchText}
            setSearchText={setSearchText}
            refreshApis={refreshApis}
            setSelectedUserIds={setSelectedUserIds}
            selectedUserIds={selectedUserIds}
          />
        ) : (
          <NoStudents setCreateBatchFlag={setCreateBatchFlag} />
        )}
      </div>
    </>
  );
}

export default ManageStudentsMain;
